import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {findLowestPrice} from '@salesforce/retail-react-app/app/utils/product-utils'
import {Box} from '@chakra-ui/react'

const PromoCallout = ({product, ...props}) => {
    const {promotion, data} = useMemo(() => findLowestPrice(product), [product])

    // NOTE: API inconsistency - with getProduct call, a variant does not have productPromotions
    const promos = data?.productPromotions ?? product?.productPromotions ?? []
    const promo = promotion ?? promos[0]

    // calloutMsg can be html string or just plain text
    return (
        <Box
            {...props}
            data-testid="promo-callout"
            dangerouslySetInnerHTML={{__html: promo?.calloutMsg}}
        />
    )
}

PromoCallout.propTypes = {
    product: PropTypes.object
}

export default PromoCallout
